import React, { useEffect, useState,useContext } from "react";
import {
  CommonCardUi,
  SelectOption,
  InputField,
  TextArea,
} from "../../Common/CommonCard";
import { getCustomers,ListReceipt,StoreReceipt} from "../../../Utility/Api";
import { generateRandomCode, NaviGate } from '../../../Utility/function';
import { WarehouseContext } from "../../../Utility/UserContext";
import { toast } from "react-toastify";
const CreditReceipt = () => {
  const [customers, setCustomers] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [Unique, setUnique] = useState("");
  const {UserItem} = useContext(WarehouseContext)
  const [formData, setFormData] = useState({
    customer_id: "",
    transaction_no: "",
    transaction_date: "",
    payment_mode: "",
    amount: "",
    payment_mode_detail: "",
    remark: "",
  });
  const [errors, setErrors] = useState({
    customer_id: "",
    transaction_no:"",
    transaction_date: "",
    amount:"",
    payment_mode_detail:"",
    remark:"",
    opening_balance:"",
  });

  useEffect(() => {
    setUnique(generateRandomCode())
    fetchCustomers();
    ReceiptList()
  },[]);

  const ReceiptList =async()=>{
    try {
      const response = await ListReceipt()
      if (response.data && response.data.data) {
        setTableData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  }

  const fetchCustomers = async () => {
    try {
      const response = await getCustomers();
      if (response.data && response.data.data) {
        setCustomers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({})
    clearFields();
  };

  const handleSave = () => {
    try {
      // Validation logic
      if (!formData.transaction_date) {
        toast.error("Transaction date is required");
        return;
      }
      if (!UserItem?.user_id) {
        toast.error("User ID is required");
        return;
      }
      if (!formData.opening_balance || isNaN(formData.opening_balance)) {
        toast.error("Opening balance is required and must be a number");
        return;
      }
      if (!formData.payment_mode) {
        toast.error("Payment mode is required");
        return;
      }
      if (!formData.customer_id) {
        toast.error("Customer ID is required");
        return;
      }
      if (!formData.amount || isNaN(formData.amount)) {
        toast.error("Total amount is required and must be a number");
        return;
      }
  
      // Construct the data object
      const Datasave = {
        product_id: "0",
        unique_id: "CC" + Unique,
        type: "4",
        date_time: formData.transaction_date,
        user_id: UserItem?.user_id,
        amount: formData.opening_balance,
        remaining: "0",
        status: "Completed",
        mop: formData.payment_mode, // Ensure only one "mop" key
        invoice_no: "CC" + Unique,
        credit_limit: 0,
        remark: formData.remark,
        discount: 0,
        customer_id: formData.customer_id,
        tax: 0,
        total: formData.amount,
        payment_status: 1,
      };
  
      // Store data if all fields are valid
      StoreReceipt(Datasave);
      toast.success("Created Successfully");
      clearFields();
    } catch (error) {
      toast.error("Data Not Stored");
    }
  };
  

  const clearFields = () => {
    setFormData({
      customer_id: "",
      transaction_no: "",
      transaction_date: "",
      payment_mode: "",
      amount: "",
      payment_mode_detail: "",
      remark: "",
      opening_balance:"",
      CR_DR:""
    });
    setErrors({})

  };

  const fields = (
    <>
      <div className="col-lg-6 col-12">
        {/* Customer Select Option */}
        {SelectOption(
          "Customer",
          "customer_id",
          formData.customer_id,
          handleChange,
          "Select Customer",
          customers.filter(item => item.status != 1)
        )}

        {/* Transaction No */}
        {InputField(
          "Transaction No",
          "transaction_no",
          "text",
          formData.transaction_no,
          handleChange,
          "Enter Transaction No",
          12,
          null,
          errors.transaction_no
        )}

        {/* Transaction Date */}
        {InputField(
          "Transaction Date",
          "transaction_date",
          "date",
          formData.transaction_date,
          handleChange,
          "Select Transaction Date",
          12,
          null,
          errors.transaction_date
        )}

        {/* Payment Mode */}
        {InputField(
          "Payment Mode",
          "payment_mode",
          "text",
          formData.payment_mode,
          handleChange,
          "Enter Payment Mode",
          12,
          null,
          errors.payment_mode
        )}

        {/* Amount */}
        {InputField(
          "Amount",
          "amount",
          "number",
          formData.amount,
          handleChange,
          "Enter Amount",
          12,
          null,
          errors.amount
        )}

        {/* Payment Mode Detail */}
        {InputField(
          "Payment Mode Detail",
          "payment_mode_detail",
          "text",
          formData.payment_mode_detail,
          handleChange,
          "Enter Payment Mode Detail",
          12,
          null,
          errors.payment_mode_detail
        )}
      </div>

      <div className="col-lg-6 col-12">
        {/* Remark */}
        <div className="text-small">
          {TextArea(
            " Remark",
            "remark",
            "text",
            formData.remark,
            handleChange,
            "give some additional details",
            12,
            true
          )}
        </div>

        {/* Balance */}
        <div className="d-flex column-gap-1">
          {InputField(
            "Balance",
            "opening_balance",
            "text",
            formData.opening_balance,
            handleChange,
            "Enter Balance",
            8,
            null,
            errors.opening_balance
          )}
          <div className="col-4">
            <select
              name="CR_DR"
              value={formData.CR_DR}
              onChange={handleChange}
              style={{
                height: "1.5rem",
                margin: "1px",
                fontSize: "0.7rem",
              }}>
              <option value="">Select CR DR</option>
              <option key="0" value="0">
                CR
              </option>
              <option key="1" value="1">
                DR
              </option>
            </select>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className="page-wrappers">
      <div className="page-content">
      <NaviGate />
        <h6 className="mb-0 text-uppercase">Credit Receipt</h6>
        <hr />
        <CommonCardUi
          feilds={fields}
          onSave={handleSave}
          onCancel={clearFields}
        />
        <div className="mt-2">
          <h6>Transaction Records</h6>
          <table className="table table-bordered" style={{ minInlineSize:"400px"}}>
            <thead>
              <tr>
                <th>#</th>
                <th>Customer ID</th>
                <th>Customer</th>
                <th>Payment Mode</th>
                <th>Amount (INR)</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.filter(item=>item.amount).map((data, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{data.unique_id}</td>
                    <td>{data.customer_id}</td> 
                    <td>{data.amount}</td>
                    <td>{data.total}</td>
                    <td>{data.remark}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default CreditReceipt;
